import { POLL, TUG, SCOREBOARD, GIVEAWAY } from 'lib/elementCanvas'
import { SceneElement } from 'types/api'

export interface ElementBase { w: number, h: number }

export const ELEMENT_BASE: Record<SceneElement['elementKind'], ElementBase> = {
  POLL: { w: POLL.width, h: 400 },
  TUG: { w: TUG.width, h: TUG.height },
  BOARD: { w: SCOREBOARD.width, h: SCOREBOARD.height },
  CHAT: { w: 480, h: 1080 },
  EMOTEWALL: { w: 640, h: 1080 },
  MERCH: { w: 610, h: 730 },
  MERCH_TICKER: { w: 1920, h: 105 },
  CAMERA_CONTROL: { w: 480, h: 270 },
  GIVEAWAY: { w: GIVEAWAY.width, h: 560 },
  TRIVIA: { w: POLL.width, h: 400 },
  TICKER_BAR: { w: 1920, h: 85 }
}

export const MIN_LAYOUT: Record<SceneElement['elementKind'], number> = {
  POLL: 280,
  TUG: 620,
  BOARD: 200,
  CHAT: 160,
  EMOTEWALL: 160,
  MERCH: 400,
  MERCH_TICKER: 480,
  CAMERA_CONTROL: 160,
  GIVEAWAY: 480,
  TRIVIA: 280,
  TICKER_BAR: 480
}

export interface ResolvedElementBox {
  w: number
  h: number
  glyphScale: number
  layoutWidth: number
}

export const deriveDefaultBox = (
  kind: SceneElement['elementKind'],
  scale: number
): { w: number, h: number } => ({
  w: Math.round(ELEMENT_BASE[kind].w * scale),
  h: Math.round(ELEMENT_BASE[kind].h * scale)
})

export const resolveElementBox = (el: SceneElement): ResolvedElementBox => {
  const base = ELEMENT_BASE[el.elementKind]
  if (el.w == null || el.h == null) {
    return {
      ...deriveDefaultBox(el.elementKind, el.scale),
      glyphScale: el.scale,
      layoutWidth: base.w
    }
  }
  const glyphScale = el.elementKind === 'TUG' || el.elementKind === 'BOARD'
    ? el.h / base.h
    : el.scale
  return {
    w: el.w,
    h: el.h,
    glyphScale,
    layoutWidth: Math.max(
      MIN_LAYOUT[el.elementKind],
      Math.round(el.w / glyphScale)
    )
  }
}
